<div class="picker" [formGroup]="categoryForm">
    @if(!typeOfService) {
    <mat-form-field appearance="outline" floatLabel="always" style="width: 100%;">
        <mat-label>Service Request Category</mat-label>
        <input type="text" matInput formControlName="category" [matAutocomplete]="categoryAuto"
            placeholder="Search for a category..." />

        <mat-autocomplete #categoryAuto="matAutocomplete" [displayWith]="displayCategory">
            @for(option of filteredCategoryOptions; track option.code) {
            <mat-option [value]="option">
                <strong>{{ option.display }}</strong>
                @if(option.code) {
                <span class="text-muted"> ({{ option.code }})</span>
                }
            </mat-option>
            }
            @empty {
            <mat-option disabled>No categories found.</mat-option>
            }
        </mat-autocomplete>
    </mat-form-field>
    }

    <mat-form-field appearance="outline" floatLabel="always" style="width: 100%;">
        <mat-label>Service Request Code</mat-label>
        <input type="text" matInput formControlName="serviceRequestCode" [matAutocomplete]="serviceRequestAuto"
            placeholder="Search for a service...">

        @if(loadingServiceRequests) {
        <mat-icon matSuffix>
            <span class="spinner-border spinner-border-sm"></span>
        </mat-icon>
        }

        <mat-autocomplete #serviceRequestAuto="matAutocomplete" [displayWith]="displayServiceCode"
            [requireSelection]="mustChooseFromOptions">
            @for(option of filteredServiceRequestOptions; track option.code) {
            <mat-option [value]="option">
                <strong>{{ option.display }}</strong>
                @if(option.code) {
                <span class="text-muted"> ({{ option.code }})</span>
                }
            </mat-option>
            }
            @empty {
            @if(!loadingServiceRequests) {
            <mat-option disabled>
                No service codes found.
                @if(!requireCategory){
                Try a different search term.
                }
                @else {
                Select a category first.
                }
            </mat-option>
            }
            }
        </mat-autocomplete>
    </mat-form-field>
</div>